export default "__VITE_ASSET__CiAodR5P__"